import { render, staticRenderFns } from "./Hub.vue?vue&type=template&id=5ef63452&"
import script from "./Hub.vue?vue&type=script&lang=js&"
export * from "./Hub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports